import { formatPercent } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class StorageOverseerBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.STORAGE_OVERSEER;

	public get description(): string {
		return super.description.replace(
			"{percent}",
			formatPercent(
				(this.config.production.get(
					ResourceType.STORAGE_RESOURCE_MULTIPLIER,
				)! as number) - 1,
			),
		);
	}
}

export default StorageOverseerBuildingTileEntity;
